import { BaseService } from "core/services";
import { FacilityOrderTemplateNoteRouteService } from "application/facility-order/services";

class FacilityOrderTemplateNoteService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new FacilityOrderTemplateNoteRouteService());
	}
}

export default FacilityOrderTemplateNoteService;